<template>
    <jet-dialog-modal :show="isShow" maxWidth="3xl" @close="closePhotoChangePopUp" role="dialog" aria-modal="true">
        <template #title>
            <div class="text-lg">
                <div class="flex justify-between items-center">
                    <h2 class="sm:pt-4 pt-2 lg:text-2xl sm:text-lg text-sm mb-2"> Change Photo </h2><jet-secondary-button class="cursor-pointer" aria-label="Close"
                        @click="closePhotoChangePopUp">X</jet-secondary-button>
                </div>
            </div>
        </template>

        <template #content>
            <div class="w-full">
                <form action="#" @submit.prevent="false">

                    <div class="loader-15" v-if="uploadProgress"></div>
                    <div v-else>

                        <div v-if="optionSetimage" class="relative w-24 mb-5 mx-auto">
                            <img :src="optionSetimage" class="xl:mt-0 w-full h-24 object-cover" width="100" height="100" alt="Photo" />
                        </div>

                        <div class="space-y-8 font-[sans-serif] max-w-md mx-auto">
                        </div>
                        <label for="uploadFile1"
                            class="bg-blue-100 border-2 border-blue-500 text-blue-500 text-base rounded w-full flex items-center justify-center cursor-pointer gap-2 mb-5 py-2 px-5">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                                stroke="currentColor" data-slot="icon" class="w-4 h-4">
                                <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
                            </svg>
                            Upload photo
                            <input type="file" id='uploadFile1' class="hidden" accept="image/*" name="mc_option_image"
                                v-on:change="onMCOptionImageChange" />
                        </label>
                        <div v-if="imageErrorMessage" class="validation_error_msg">This field is required.</div>
                        <button type="submit" @click="updateMenuCycleDayOptionsPhoto"
                            class="md:w-24 w-full button-color text-white font-bold py-3 rounded md:mt-0 mt-4 px-4 leading-4 mx-auto bg-[#38558e]">UPDATE</button>
                    </div>
                </form>

            </div>
        </template>

    </jet-dialog-modal>
</template>

<script>
import vClickOutside from "click-outside-vue3";
var moment = require('moment');
import JetDialogModal from "@/Jetstream/DialogModal";


// import { inject } from 'vue';


export default {

    // setup() {
    //     const message1 = inject('firstFunction');
    //     const message2 = inject('secondFunction');

    // },
    props: ['products', 'date', 'userLoginCheck', 'closeCalendarPopUp'],
    components: {
        vClickOutside,
        JetDialogModal
    },

    data() {
        return {
            isShow: false,
            optionImage: "",
            menu_cycle_day_options_id: '',
            imageErrorMessage: false,
            optionSetimage: '',
            uploadProgress: '',
            productValue: '',
        }
    },

    methods: {
        showPhotoChangePopUp(p) {
            this.productValue = p;
            this.menu_cycle_day_options_id = p.id
            this.isShow = true;
            console.log('productValueproductValue', this.productValue);
        },

        hideShowLoader(types) {
            if (types == "show") {
                document.getElementById("full_loader").style.display = "flex";
            } else {
                document.getElementById("full_loader").style.display = "none";
            }
        },

        closePhotoChangePopUp() {
            this.imageErrorMessage = false;
            this.optionSetimage = '';
            this.isShow = false;
        },

        updateMenuCycleDayOptionsPhoto() {
            this.hideShowLoader('show');
            if (this.optionImage == null || this.optionImage == '') {
                this.imageErrorMessage = true;
                this.hideShowLoader('hide');
            } else {
                axios.post('/update-menu-cycle-day-options-photo', { menu_cycle_day_options_id: this.menu_cycle_day_options_id, mc_option_image: this.optionImage })
                    .then((response) => {
                        this.productValue.photo = response.data.photo_store_path;
                        this.productValue.photo_store_path = response.data.photo_store_path;
                        this.hideShowLoader('hide');
                        this.optionSetimage = '';
                        this.isShow = false;
                        this.$emit('closeCalendarPopUp');
                        // this.$emit('loadExcludedDateData');
                        // this.$emit('loadCalendar');

                        // return { message1, messge2};
                        console.log(response.data);
                    })
                    .catch(error => console.error(error));
            }

        },

        onMCOptionImageChange(e) {
            let $this = this;
            // this.optionImage = e.target.files[0];
            let img_file = e.target.files || e.dataTransfer.files;

            if (!img_file.length) {
                return;
            } else {
                console.log('hello3');
                this.uploadProgress = true;
                this.createMCOptionImage(img_file[0]);
                Vapor.store(e.target.files[0], {
                    visibility: 'public-read',
                    progress: (progress) => { },
                }).then((response) => {
                    this.uploadProgress = false;
                    $this.optionImage = response;
                    //   console.log("vapor response", response);
                    console.log('imageoption', this.optionImage);
                });
            }
        },

        createMCOptionImage(file) {
            let reader = new FileReader();
            let vm = this;
            reader.onload = (e) => {
                vm.optionSetimage = e.target.result;
            };
            reader.readAsDataURL(file);
        },

    }
}
</script>

<style scoped>
.box-hover .bg-white.popup-shadow {
    font-size: 12px;
    width: 460px;
    max-width: 100vw;
}

.bg-white.popup-shadow {
    padding: 0px;
}

.box-hover .bg-white.popup-shadow li.text-black {
    padding: 3px 8px;
    margin-bottom: 5px;
}

/* .button-none{
    bottom: -100%;
    z-index: 10;
    } */

/* .box-hover{
    overflow: hidden;
    } */
/* .box-hover:hover .button-none{
    bottom: 0;
    } */

.bottom-0-space {
    bottom: 6px;
}
</style>

<style scoped>
.box-hover .bg-white.popup-shadow {
    font-size: 12px;
    width: 460px;
    max-width: 100vw;
}

.bg-white.popup-shadow {
    padding: 0px;
}

.box-hover .bg-white.popup-shadow li.text-black {
    padding: 3px 8px;
    margin-bottom: 5px;
}

/* .button-none{
bottom: -100%;
z-index: 10;
} */

/* .box-hover{
overflow: hidden;
} */
/* .box-hover:hover .button-none{
bottom: 0;
} */

.bottom-0-space {
    bottom: 6px;
}
</style>

<style>
.font-24 {
    font-size: 24px;
}

.color-24 {
    color: #636363;
}

.p-color {
    color: #969696;
}

.p-size {
    font-size: 15px;
}

.online-color {
    color: #22af4b;
}

.offline-color {
    color: #cb0000;
}

.number-background-color {
    background-color: #cb0000;
}

.online-background-color {
    background-color: #22af4b;
}

.week-cycle-color {
    color: #1c2a47;
}

.week-cycle-fontsize {
    font-size: 14px;
}

.three-dot-color {
    color: #38558e;
}

.table-background {
    background-color: #f3f3f3;
}

.last-td-background {
    background-color: white !important;
    opacity: 0.7;
}

.td-width {
    width: 14.28%;
    min-height: 135px;
    min-width: 170px;
}

.td-width .absolute-div {
    left: 35px;
}

.cart-color {
    color: #f7a53a;
}

.plus-font-size {
    font-size: 20px;
}

.menu-day-background {
    background-color: #cbcbcb;
}

.box-sizing {
    width: 100px;
    min-height: 60px;
}

.popup-shadow {
    box-shadow: 0px 5px 10px #0000005e;
}

.w-52 {
    width: 185px;
    width: 185px;
    max-height: 161px;
    overflow: auto;
    overflow-x: hidden;
}

.w-3 {
    width: 60px;
    height: 60px;
}

.hover_font_size {
    font-size: 13px;
    font-weight: bold;
    text-decoration: underline;
}

.title_color {
    color: #f7a53a;
}

.popup-shadow {
    box-shadow: 0px 5px 10px #0000005e;
}

.show-box {
    display: block !important;
}

.hide-box {
    display: none !important;
}

/* .box-type-show:hover .show-box {
    display: block;
} */

.absolute-div {
    position: absolute;
    top: 0px;
    left: 50px;
}

.add_food_color {
    background-color: #38558e;
}

.absolute-items {
    position: absolute;
    top: 0px;
    right: 0px;
    left: 0px;
    bottom: 0px;
    margin: auto;
}

.absolute-items2 {

    position: absolute;
    right: 8px;
    bottom: 8px;
    margin: auto;
}

.text-color-circle-icon {
    color: #38558e;
}

.mh-135 {
    min-height: 256px;
    padding: 4px;
}

.mh-135>div {
    padding: 4px;
}

.mh-135>div img {
    object-fit: cover;
}

span.option_title {
    line-height: 17px;
    padding-bottom: 10px;
}


.loader-15 {
    background: currentcolor;
    position: relative;
    animation: loader-15 1s ease-in-out infinite;
    animation-delay: 0.4s;
    width: 0.25em;
    height: 0.5em;
    margin: 37px auto;
}

.loader-15:after,
.loader-15:before {
    content: "";
    position: absolute;
    width: inherit;
    height: inherit;
    background: inherit;
    animation: inherit;
}

.loader-15:before {
    right: 0.5em;
    animation-delay: 0.2s;
}

.loader-15:after {
    left: 0.5em;
    animation-delay: 0.6s;
}

@keyframes loader-15 {

    0%,
    100% {
        box-shadow: 0 0 0 currentcolor, 0 0 0 currentcolor;
    }

    50% {
        box-shadow: 0 -0.25em 0 currentcolor, 0 0.25em 0 currentcolor;
    }
}</style>
